import React, { useState } from "react";
import { Alert, Button, Spinner } from "react-bootstrap";

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }

  return "";
}

function getApiBaseUrl() {
  return process.env.REACT_APP_BASE_API || "/";
}

function getApiUrl(path) {
  const baseUrl = getApiBaseUrl();
  const cleanBaseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
  const cleanPath = path.startsWith("/") ? path.slice(1) : path;

  return `${cleanBaseUrl}${cleanPath}`;
}

function SolicitudDecisionActions({ rut, estado = "", onAccepted, onDiscarded }) {
  const [loadingAction, setLoadingAction] = useState("");
  const [feedback, setFeedback] = useState(null);

  const buildBody = () => {
    const data = new URLSearchParams();

    data.append("rut", rut);
    data.append("estado", estado || "");

    return data.toString();
  };

  const handleAction = async ({ url, actionName }) => {
    setLoadingAction(actionName);
    setFeedback(null);

    try {
      const response = await fetch(getApiUrl(url), {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRFToken": getCookie("csrftoken"),
        },
        body: buildBody(),
      });

      const data = await response.json();

      if (!response.ok || data.success === false || data.status === "error") {
        throw new Error(data.message || "No se pudo completar la acción.");
      }

      if (actionName === "accept" && onAccepted) {
        onAccepted(rut);
      }

      if (actionName === "discard" && onDiscarded) {
        onDiscarded(rut);
      }
    } catch (error) {
      setFeedback({
        type: "danger",
        message: error.message || "No se pudo completar la acción.",
      });
    } finally {
      setLoadingAction("");
    }
  };

  return (
    <div className="solicitudes-decision-actions">
      {feedback && (
        <Alert variant={feedback.type} className="solicitudes-decision-alert">
          {feedback.message}
        </Alert>
      )}

      <div className="solicitudes-decision-buttons">
        

        <Button
          variant="primary"
          disabled={Boolean(loadingAction)}
          onClick={() =>
            handleAction({
              url: "api/formularios/agregar_maestra/",
              actionName: "accept",
            })
          }
        >
          {loadingAction === "accept" ? (
            <Spinner animation="border" size="sm" />
          ) : (
            "Agregar como Maestra"
          )}
        </Button>
        <Button
          variant="danger"
          disabled={Boolean(loadingAction)}
          onClick={() =>
            handleAction({
              url: "api/formularios/descartar_maestra/",
              actionName: "discard",
            })
          }
        >
          {loadingAction === "discard" ? (
            <Spinner animation="border" size="sm" />
          ) : (
            "Descartar como Maestra"
          )}
        </Button>
      </div>
    </div>
  );
}

export default SolicitudDecisionActions;